import { Component } from '@angular/core';
import validationEngine from 'devextreme/ui/validation_engine';
import { DevExtremeModule } from 'devextreme-angular';
import { CdrUnitOfWork } from 'src/app/core/core.module';
import { CustomerRateUpdate } from 'src/app/core/model/customer-rate-update';
import { BaseDialogComponent } from 'src/app/shared/base-dialog/base-dialog.component';

@Component({
    selector: 'app-rate-update-dialog',
    standalone: true,
    imports: [DevExtremeModule],
    template: `
        <dx-popup
            title="Edit Rate Increase"
            [width]="400"
            [height]="'auto'"
            [(visible)]="visible"
            [hideOnOutsideClick]="false"
            (onHiding)="onHiding($event)"
            >
            <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
            </dxi-popup-toolbar-item>
            <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
            </dxi-popup-toolbar-item>
            <dx-form [formData]="update" validationGroup="rateUpdateValidationGroup">
                <dxi-form-item dataField="increaseDate" editorType="dxDateBox" [label]="{ text: 'Scheduled Date' }">
                    <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
                </dxi-form-item>
                <dxi-form-item
                    dataField="amount"
                    editorType="dxNumberBox"
                    [editorOptions]="{ format: { type: 'currency', precision: 2 } }"
                    [label]="{ text: 'Amount' }"
                    >
                    <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
                </dxi-form-item>
            </dx-form>
        </dx-popup>
    `
})
export class RateUpdateDialogComponent extends BaseDialogComponent<any> {
    update: CustomerRateUpdate;

    constructor(private uow: CdrUnitOfWork) {
        super();
    }

    save = async () => {
        if (!this.valid()) return;

        await this.uow.commit();
        this.hide({ success: true, value: this.update });
    };

    cancel = async () => {
        this.uow.rollback();
        this.hide({ success: false });
    };

    valid() {
        const groupConfig = validationEngine.getGroupConfig('rateUpdateValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('rateUpdateValidationGroup');
            return result.isValid;
        } else return false;
    }
}
